import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import styles from "./Footer.module.css";
import FabButton from "../Fab/Fab";

const Footer = () => {
  const location = useLocation();
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("profile")));

  useEffect(() => {
    setUser(JSON.parse(localStorage.getItem("profile")));
  }, [location]);

  return (
    <footer className={styles.footer}>
     
        <div>
          Powered by Elixir Technologies Pvt. Ltd.
        </div>
     
      {/* {user && (
        <div style={{ marginBottom: "2rem" }}>
          <FabButton />
        </div>
      )} */}
    </footer>
  );
};

export default Footer;
